import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function TraditionalCom() {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <Box sx={{ position : 'relative'}}>
        <Box className="traditional_back">
          <Container maxWidth="xl">
            <Box
              sx={{
                maxWidth: "1400px",
                padding: {xs: '65px 0px 107px' , lg: "140px 0px"},
                margin: "auto",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#212529",
                  fontSize: {xs: 36 , lg:72},
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  lineHeight: {xs: '44px' , lg: "87px"},
                }}
              >
                Povego'nun misyonu ve vizyonu
              </Typography>
              <Typography
                sx={{
                  color: "#212529",
                  fontSize: {xs: 18 , lg: 22},
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  maxWidth: "1180px",
                  padding: {xs: '44px 0px 60px 0px' , lg: "54px 0px 60px 0px"},
                  margin: "auto",
                }}
              >
                Misyonumuz: Blokzincir üzerindeki kripto varlıkları, yatırımcılara, güvenli ve yenilikçi bir yatırım ekosistemi ile sunma misyonuyla hareket ediyoruz. 
                <br/><br/>
                Vizyonumuz: Türkiye’nin blokzincir tabanlı yatırım platformu olarak geleceğin yatırım dünyasındaki öncü rolümüzü global arenaya taşımayı hedefliyoruz.
              </Typography>
              
            </Box>
          </Container>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default TraditionalCom;
